/**
 * sl-9qm.22: Doc-Reference Column Configuration — Zod Schema
 *
 * Validates DocReferenceColumnConfig for the config panel.
 */
import { z } from 'zod';

export const docReferenceRenderModeSchema = z.enum([
  'excerpt',
  'full',
  'title-only',
]);

export const docReferenceColumnConfigSchema = z.object({
  type: z.literal('doc-reference'),
  renderMode: docReferenceRenderModeSchema.default('excerpt'),
  maxExcerptLength: z.number().int().min(50).max(2000).optional(),
  showLastModified: z.boolean().optional(),
});

export type DocReferenceColumnConfigSchema = z.infer<
  typeof docReferenceColumnConfigSchema
>;
